// Pricing values are in USD and exclude VAT. Each entry is verified against
// the vendor's own pricing page on the `asOf` date. Re-check monthly and bump
// `asOf` only when actually re-checked.

const LUCKYNOTE_PRICING = {
    currency: 'USD',
    freeTier: 'Yes',
    paid: '$7.99/mo or $59.99/yr',
    asOf: '2026-09-24'
};

const COMPETITOR_PRICING = {
    raindrop: {
        name: 'Raindrop',
        currency: 'USD',
        freeTier: 'Yes — unlimited bookmarks, 100 MB uploads/mo',
        paid: 'Pro $3/mo or $28/yr',
        asOf: '2026-07-29',
        sourceUrl: 'https://raindrop.io/pro/buy'
    },
    mymind: {
        name: 'mymind',
        currency: 'USD',
        freeTier: 'No free plan',
        paid: 'From $4.99/mo; $7.99/mo or $79/yr',
        asOf: '2026-07-29',
        sourceUrl: 'https://access.mymind.com/pricing'
    },
    glasp: {
        name: 'Glasp',
        currency: 'USD',
        freeTier: 'Yes — unlimited public highlights and a monthly AI quota',
        paid: 'Pro $15/mo, or $150/yr ($12.50/mo)',
        asOf: '2026-09-24',
        sourceUrl: 'https://glasp.co/pricing'
    },
    otter: {
        name: 'Otter',
        currency: 'USD',
        freeTier: 'Yes — 300 transcription min/mo',
        paid: 'Pro $16.99/mo, or $8.33/mo billed annually',
        asOf: '2026-07-29',
        sourceUrl: 'https://otter.ai/pricing'
    },
    voicenotes: {
        name: 'VoiceNotes',
        currency: 'USD',
        freeTier: 'Yes — 100 min/wk, 30-day history',
        paid: 'Pro $9/mo',
        asOf: '2026-07-29',
        sourceUrl: 'https://voicenotes.com/pricing'
    },
    fabric: {
        name: 'Fabric',
        currency: 'USD',
        freeTier: 'No free plan listed',
        paid: 'Plus $10/mo, or $8/mo billed yearly ($96/yr)',
        asOf: '2026-07-29',
        sourceUrl: 'https://fabric.so/pricing-and-plans-for-individuals'
    },
    dropbox: {
        name: 'Dropbox',
        currency: 'USD',
        freeTier: 'Yes — 2 GB Basic',
        paid: 'Plus $11.99/mo, or $9.99/mo billed yearly (2 TB)',
        asOf: '2026-07-29',
        sourceUrl: 'https://www.dropbox.com/plans'
    },
    pocket: {
        name: 'Pocket',
        currency: 'USD',
        freeTier: 'Shut down in 2025',
        paid: 'No longer available',
        asOf: '2026-07-29',
        sourceUrl: null
    },
    'apple-notes': {
        name: 'Apple Notes',
        currency: 'USD',
        freeTier: 'Yes — built into every iPhone, iPad and Mac',
        paid: 'No paid tier; included free with an Apple device',
        asOf: '2026-07-29',
        sourceUrl: null
    },
    evernote: {
        name: 'Evernote',
        currency: 'USD',
        freeTier: 'Yes — 50 notes, 1 notebook, 1 device, 1 GB uploads/mo',
        paid: 'Starter $99/yr ($8.25/mo billed annually) · Advanced $249.99/yr ($20.83/mo billed annually)',
        asOf: '2026-07-29',
        sourceUrl: 'https://evernote.com/compare-plans'
    },
    obsidian: {
        name: 'Obsidian',
        currency: 'USD',
        freeTier: 'Yes — the core app is free with unlimited use',
        paid: 'Sync from $4/user/mo billed annually ($5 monthly) · Publish from $8/site/mo billed annually ($10 monthly)',
        asOf: '2026-07-29',
        sourceUrl: 'https://obsidian.md/sync'
    },
    notion: {
        name: 'Notion',
        currency: 'USD',
        freeTier: 'Yes — free for individuals',
        paid: 'Plus $10/mo billed annually ($12/mo monthly) · Business $20/mo billed annually ($24/mo monthly)',
        asOf: '2026-11-01',
        sourceUrl: 'https://www.notion.com/pricing'
    },
    capacities: {
        name: 'Capacities',
        currency: 'USD',
        freeTier: 'Yes — free Basic plan with unlimited spaces, objects, and blocks',
        paid: 'Pro $9.99/mo (approx. $119.88/yr) · Believer from $12.49/mo',
        asOf: '2026-11-01',
        sourceUrl: 'https://capacities.io/pricing'
    },
    'google-keep': {
        name: 'Google Keep',
        currency: 'USD',
        freeTier: 'Yes — free with a Google account (15 GB shared across Drive, Gmail and Photos)',
        paid: 'No paid Keep tier; extra Google storage from $1.99/mo for 100 GB (Google One)',
        asOf: '2026-07-29',
        sourceUrl: 'https://one.google.com/about/plans'
    },
    'google-drive': {
        name: 'Google Drive',
        currency: 'USD',
        freeTier: 'Yes — 15 GB shared across Drive, Gmail and Photos',
        paid: 'Google One storage from $1.99/mo for 100 GB',
        asOf: '2026-07-29',
        sourceUrl: 'https://one.google.com/about/plans'
    }
};

module.exports = {
    COMPETITOR_PRICING,
    LUCKYNOTE_PRICING
};
